"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TerrainTypes_1 = require("../TerrainTypes");
var math_1 = require("../tools/math");
function generateVoid(map) {
    math_1.drawLineToSpot(map, 0, 0, map.width - 1, 0, TerrainTypes_1.TerrainTypes.Void);
    math_1.drawLineToSpot(map, map.width - 1, 0, map.width - 1, map.height - 1, TerrainTypes_1.TerrainTypes.Void);
    math_1.drawLineToSpot(map, 0, map.height - 1, map.width - 1, map.height - 1, TerrainTypes_1.TerrainTypes.Void);
    math_1.drawLineToSpot(map, 0, 0, 0, map.height - 1, TerrainTypes_1.TerrainTypes.Void);
}
exports.generateVoid = generateVoid;
